module.exports = __webpack_public_path__ + "img/imgs9.8f3790ae.png";